import React, { useEffect, useRef } from "react";
import { isYandexRefreshable, renderYandex, useAdRefresh } from "../../utils/adRefresh";

export const YandexAd = ({ blockId, type }) => {
    const ref = useRef(null);
    const round = useAdRefresh(ref, { enabled: Boolean(blockId) && isYandexRefreshable(type), refreshOnLeave: true });

    useEffect(() => {
        if (!blockId) {
            return;
        }

        renderYandex(
            {
                blockId,
                renderTo: `yandex_rtb_${blockId}`,
                ...(type && { type }),
            },
            ref.current,
            round
        );
    }, [blockId, round]);

    if (!blockId) {
        return null;
    }

    return <div ref={ref} id={`yandex_rtb_${blockId}`}></div>;
};
